import React, { useState, useEffect } from 'react';
import {
  Container, Card, Table, Button, Row, Col, Form, Pagination,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select, { components } from 'react-select';
import { useSelector } from 'react-redux';
import {
  FaPlus, FaEdit, FaTrash, FaFileAlt, FaClipboardList,
  FaCog, FaSortUp, FaSortDown, FaSort, FaComments,
  FaFileExcel, FaPaperclip,
} from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import { customStyles, DropdownIndicator, MultiValueResumido } from '~/Styles/reactSelectStyles';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import {
  getSolicitaDebMunicipioGruposEmpresa,
  getSolicitaDebMunicipioContas,
  getSolicitaDebMunicipioTipos,
  getSolicitaDebMunicipioTiposFiltro,
  getSolicitaDebMunicipioStatus,
  listarSolicitaDebMunicipio,
  excluirSolicitaDebMunicipio,
  exportarSolicitaDebMunicipioExcel,
} from '~/Services/Service';
import NovaSolicitacaoModal from './NovaSolicitacaoModal';
import AlterarStatusModal from './AlterarStatusModal';
import GerarRequerimentoModal from './GerarRequerimentoModal';
import TiposSolicitacaoModal from './TiposSolicitacaoModal';
import AnexosModal from './AnexosModal';
import SolicitaDebMunicipioOcorrenciaDrawer from './SolicitaDebMunicipioOcorrenciaDrawer';
import './index.scss';

const PREFIXO_DEBITOS = 'SOLICITAÇÃO DE DÉBITOS';
const TAMANHOS_PAGINA = [10, 25, 50, 100];

// W-0495 — em laptop as 25 linhas do padrão não cabem na altura útil: a grid empurra a
// paginação para fora da dobra e o usuário precisa rolar a página para trocar de página.
// O corte é por largura de viewport (mesmo critério de breakpoint usado no resto do
// extranet) — 1600px pega os laptops (1366/1440/1536/1600) e deixa de fora o monitor FHD+
// de mesa. Nada é escondido: reduzir a fatia por página aumenta o total de páginas na mesma
// proporção, e o combo "Por página" continua disponível para quem quiser mais linhas.
// Em 4K (2560x1498) as 25 linhas repetem o mesmo sintoma, então o padrão de mesa também é 10.
const MEDIA_LAPTOP = '(max-width: 1600px)';
const TAMANHO_PAGINA_LAPTOP = 10;
const TAMANHO_PAGINA_DESKTOP = 10;

const tamanhoPaginaPadrao = () => (
  window.matchMedia(MEDIA_LAPTOP).matches ? TAMANHO_PAGINA_LAPTOP : TAMANHO_PAGINA_DESKTOP
);

// DW-1019 — o controle do filtro resume em "N selecionados", então o menu é o único lugar
// onde dá pra ver o que está marcado. O `option` do customStyles pinta só por isFocused, ou
// seja, item selecionado e não-selecionado ficariam visualmente idênticos — o checkbox resolve.
const OpcaoComCheckbox = (props) => {
  const { isSelected, label } = props;
  return (
    <components.Option {...props}>
      <input type="checkbox" checked={isSelected} readOnly style={{ marginRight: 8 }} />
      {label}
    </components.Option>
  );
};

const DebitosMunicipais = () => {
  const usuario = AuthStorage.getUser() || {};
  const codigoUsuario = usuario.codigo_usuario || usuario.Codigo_Usuario || 0;
  const isResponsavel = AuthStorage.temCaracteristicas([caracteristicas.RespDebMunicipaisCond]);

  const [filtros, setFiltros] = useState({
    codigo_familia: null,
    codigo_grupo_empresa: null,
    codigo_conta: null,
    dt_ini: '',
    dt_fim: '',
    status: null,
    // DW-1019 — filtro de tipo é multi-seleção; lista vazia = "Todos".
    codigos_tipo_solicitacao: [],
    codigo_usuario: null,
  });

  const empreendimentosRedux = useSelector((state) => state.empreendimentos);
  const optionsEmpreendimentos = (empreendimentosRedux && empreendimentosRedux.sort
    ? empreendimentosRedux.sort
    : []).map((item) => ({
    value: item.codigo,
    label: `${item.codigo} - ${item.descricao}`,
  }));
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selecionados, setSelecionados] = useState(new Set());
  const [ordenacao, setOrdenacao] = useState({ campo: 'dt_inicio', direcao: 'desc' });
  const [pagina, setPagina] = useState(1);
  const [tamanhoPagina, setTamanhoPagina] = useState(tamanhoPaginaPadrao);
  // Escolha explícita no combo "Por página" vira preferência do usuário e passa a ter
  // precedência sobre o padrão por breakpoint (ver efeito abaixo).
  const [tamanhoPaginaManual, setTamanhoPaginaManual] = useState(false);
  const [modalAtivo, setModalAtivo] = useState(null);
  const [registroAtivo, setRegistroAtivo] = useState(null);
  const [confirmacao, setConfirmacao] = useState({ show: false, item: null });
  const [exportando, setExportando] = useState(false);

  const [gruposEmpresa, setGruposEmpresa] = useState([]);
  const [contas, setContas] = useState([]);
  // `tiposSolicitacao` alimenta os modais (nova solicitação / alterar status) e exclui o 48.
  // `tiposSolicitacaoFiltro` alimenta só o combo de filtro e inclui o 48 (DW-1019, .pas:2823-2828).
  const [tiposSolicitacao, setTiposSolicitacao] = useState([]);
  const [tiposSolicitacaoFiltro, setTiposSolicitacaoFiltro] = useState([]);
  const [statusList, setStatusList] = useState([]);

  const mapTipos = (resp) =>
    (resp || []).map((t) => ({ value: t.codigo, label: `${t.codigo} - ${t.assunto}`, assunto: t.assunto }));

  const recarregarTiposSolicitacao = async () => {
    try {
      const [respTipos, respTiposFiltro] = await Promise.all([
        getSolicitaDebMunicipioTipos(),
        getSolicitaDebMunicipioTiposFiltro(),
      ]);
      setTiposSolicitacao(mapTipos(respTipos));
      setTiposSolicitacaoFiltro(mapTipos(respTiposFiltro));
    } catch (err) {
      toast.error('Erro ao recarregar tipos de solicitação.');
    }
  };

  useEffect(() => {
    const carregarCombos = async () => {
      try {
        const [respGe, respTipos, respTiposFiltro, respStatus] = await Promise.all([
          getSolicitaDebMunicipioGruposEmpresa(),
          getSolicitaDebMunicipioTipos(),
          getSolicitaDebMunicipioTiposFiltro(),
          getSolicitaDebMunicipioStatus(),
        ]);
        setGruposEmpresa(
          (respGe || []).map((g) => ({ value: g.codigo, label: `${g.codigo} - ${g.apelido}` }))
        );
        setTiposSolicitacao(mapTipos(respTipos));
        setTiposSolicitacaoFiltro(mapTipos(respTiposFiltro));
        setStatusList(
          (respStatus || []).map((s) => ({ value: s.codigo, label: `${s.codigo} - ${s.nome}` }))
        );
      } catch (err) {
        toast.error('Erro ao carregar opções de filtro.');
      }
    };
    carregarCombos();
  }, []);

  // Reavalia o padrão quando a viewport cruza o breakpoint (dock/undock, F11, mudança de
  // zoom). Não sobrescreve escolha manual: quem selecionou 50 no combo continua com 50 ao
  // conectar o monitor externo.
  useEffect(() => {
    const mq = window.matchMedia(MEDIA_LAPTOP);
    const handler = (e) => {
      if (tamanhoPaginaManual) return;
      setTamanhoPagina(e.matches ? TAMANHO_PAGINA_LAPTOP : TAMANHO_PAGINA_DESKTOP);
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [tamanhoPaginaManual]);

  useEffect(() => {
    if (filtros.codigo_grupo_empresa) {
      const carregarContas = async () => {
        try {
          const resp = await getSolicitaDebMunicipioContas(filtros.codigo_grupo_empresa);
          setContas(
            (resp || []).map((c) => ({ value: c.codigo, label: `${c.codigo} - ${c.apelido}` }))
          );
        } catch (err) {
          setContas([]);
        }
      };
      carregarContas();
    } else {
      setContas([]);
      setFiltros((prev) => ({ ...prev, codigo_conta: null }));
    }
  }, [filtros.codigo_grupo_empresa]);

  const handleFiltrar = async () => {
    setLoading(true);
    setSelecionados(new Set());
    try {
      const params = {
        codigoFamilia: filtros.codigo_familia || undefined,
        codigoGrupoEmpresa: filtros.codigo_grupo_empresa || undefined,
        codigoConta: filtros.codigo_conta || undefined,
        dtIni: filtros.dt_ini || undefined,
        dtFim: filtros.dt_fim || undefined,
        status: filtros.status != null ? filtros.status : undefined,
        // CSV: query string do Web API não carrega lista (ver Listar no controller).
        tiposSolicitacao: filtros.codigos_tipo_solicitacao.length
          ? filtros.codigos_tipo_solicitacao.join(',')
          : undefined,
        codigoUsuarioResponsavel: filtros.codigo_usuario || undefined,
      };
      const resp = await listarSolicitaDebMunicipio(params);
      const registros = Array.isArray(resp) ? resp : [];
      setRegistros(registros);
      // Busca nova sempre volta pra primeira página. Atualizações pontuais de uma linha
      // (ex.: contador de anexos ao fechar o modal) não passam por aqui e preservam a página.
      setPagina(1);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // DW-1015 — extrai a planilha no formato do departamento com os filtros marcados na tela.
  // Não depende de ter clicado em Filtrar antes: o backend reaplica os mesmos filtros da listagem.
  const handleExportarExcel = async () => {
    setExportando(true);
    try {
      const payload = {
        codigo_familia: filtros.codigo_familia || null,
        codigo_grupo_empresa: filtros.codigo_grupo_empresa || null,
        codigo_conta: filtros.codigo_conta || null,
        dt_ini: filtros.dt_ini || null,
        dt_fim: filtros.dt_fim || null,
        status: filtros.status != null ? filtros.status : null,
        codigos_tipo_solicitacao: filtros.codigos_tipo_solicitacao.length
          ? filtros.codigos_tipo_solicitacao
          : null,
        codigo_usuario_responsavel: filtros.codigo_usuario || null,
      };
      const blob = await exportarSolicitaDebMunicipioExcel(payload);
      const nomeArquivo = `atendimento-cdm-${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(err.message || 'Erro ao extrair a planilha.');
    } finally {
      setExportando(false);
    }
  };

  const handleLimpar = () => {
    setFiltros({
      codigo_familia: null,
      codigo_grupo_empresa: null,
      codigo_conta: null,
      dt_ini: '',
      dt_fim: '',
      status: null,
      codigos_tipo_solicitacao: [],
      codigo_usuario: null,
    });
    setRegistros([]);
    setSelecionados(new Set());
    setPagina(1);
  };

  const handleToggleSelecionado = (codigo) => {
    setSelecionados((prev) => {
      const next = new Set(prev);
      if (next.has(codigo)) {
        next.delete(codigo);
      } else {
        next.add(codigo);
      }
      return next;
    });
  };

  const handleOrdenacao = (campo) => {
    setOrdenacao((prev) => ({
      campo,
      direcao: prev.campo === campo && prev.direcao === 'asc' ? 'desc' : 'asc',
    }));
  };

  const iconeOrdenacao = (campo) => {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  const thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  // Larguras fixas nas colunas curtas (códigos e datas) sobram espaço para os textos longos —
  // Solicitante, Empreendimento, Cliente e Tipo de Solicitação — e impedem que a tabela
  // esprema a coluna de Ações a ponto dos botões quebrarem de linha.
  const thCurta = (largura) => ({ ...thSortStyle, width: largura });

  const registrosOrdenados = [...registros].sort((a, b) => {
    const dir = ordenacao.direcao === 'asc' ? 1 : -1;
    const va = a[ordenacao.campo];
    const vb = b[ordenacao.campo];
    if (va == null) return 1 * dir;
    if (vb == null) return -1 * dir;
    if (typeof va === 'string') return va.localeCompare(vb) * dir;
    return (va - vb) * dir;
  });

  const totalPaginas = Math.max(1, Math.ceil(registrosOrdenados.length / tamanhoPagina));
  const paginaAtual = Math.min(pagina, totalPaginas);
  const inicioIdx = (paginaAtual - 1) * tamanhoPagina;
  const fimIdx = Math.min(inicioIdx + tamanhoPagina, registrosOrdenados.length);
  const registrosPagina = registrosOrdenados.slice(inicioIdx, fimIdx);

  // Não depende de `registros`: atualizar o contador de anexos de uma linha troca a referência
  // do array e jogaria o usuário de volta pra página 1. O reset por busca nova vive em
  // handleFiltrar/handleLimpar.
  useEffect(() => {
    setPagina(1);
  }, [ordenacao.campo, ordenacao.direcao, tamanhoPagina]);

  const irParaPagina = (p) => {
    if (p < 1 || p > totalPaginas) return;
    setPagina(p);
  };

  const paginasVisiveis = () => {
    const maxBotoes = 7;
    if (totalPaginas <= maxBotoes) {
      return Array.from({ length: totalPaginas }, (_, i) => i + 1);
    }
    const ini = Math.max(1, paginaAtual - 3);
    const fim = Math.min(totalPaginas, ini + maxBotoes - 1);
    const iniAjustado = Math.max(1, fim - maxBotoes + 1);
    return Array.from({ length: fim - iniAjustado + 1 }, (_, i) => iniAjustado + i);
  };

  const getRowStyle = (reg) => {
    const dias = reg.qtd_dias != null ? reg.qtd_dias : 0;
    if (reg.dt_fim == null && dias >= 10) {
      return { backgroundColor: '#ffcccc', fontWeight: 'bold' };
    }
    if (reg.tipo_solicitacao && reg.tipo_solicitacao.charAt(0) === 'E') {
      return { backgroundColor: '#C4C4FF' };
    }
    return {};
  };

  const registrosSelecionadosArray = registros.filter((r) => selecionados.has(r.codigo));

  const handleExcluir = (reg) => {
    setConfirmacao({ show: true, item: reg });
  };

  const handleConfirmarExclusao = async (confirmado) => {
    if (!confirmado) {
      setConfirmacao({ show: false, item: null });
      return;
    }
    const item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    try {
      await excluirSolicitaDebMunicipio(item.codigo);
      toast.success('Solicitação excluída com sucesso.');
      handleFiltrar();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleSuccessModal = () => {
    setModalAtivo(null);
    setRegistroAtivo(null);
    setSelecionados(new Set());
    handleFiltrar();
  };

  const abrirModal = (tipo, reg) => {
    setRegistroAtivo(reg || null);
    setModalAtivo(tipo);
  };

  return (
    <Container fluid className="px-3 py-3">
      <Header title="Atendimento — Débitos Municipais e Atualização Cadastral" />

      {/* Card de Filtros */}
      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-end">
            <Col md={3} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Empreendimento
              </Form.Label>
              <Select
                placeholder="Todos"
                isClearable
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={optionsEmpreendimentos}
                value={optionsEmpreendimentos.find((e) => e.value === filtros.codigo_familia) || null}
                onChange={(opt) =>
                  setFiltros((prev) => ({
                    ...prev,
                    codigo_familia: opt ? opt.value : null,
                  }))
                }
              />
            </Col>
            <Col md={3} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Grupo Empresa
              </Form.Label>
              <Select
                placeholder="Todos"
                isClearable
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={gruposEmpresa}
                value={gruposEmpresa.find((g) => g.value === filtros.codigo_grupo_empresa) || null}
                onChange={(opt) =>
                  setFiltros((prev) => ({
                    ...prev,
                    codigo_grupo_empresa: opt ? opt.value : null,
                    codigo_conta: null,
                  }))
                }
              />
            </Col>
            <Col md={3} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Conta
              </Form.Label>
              <Select
                placeholder="Todas"
                isClearable
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={contas}
                value={contas.find((c) => c.value === filtros.codigo_conta) || null}
                onChange={(opt) =>
                  setFiltros((prev) => ({ ...prev, codigo_conta: opt ? opt.value : null }))
                }
                isDisabled={!filtros.codigo_grupo_empresa}
              />
            </Col>
            <Col md={3} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Status
              </Form.Label>
              <Select
                placeholder="Todos"
                isClearable
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={statusList}
                value={statusList.find((s) => s.value === filtros.status) || null}
                onChange={(opt) =>
                  setFiltros((prev) => ({ ...prev, status: opt ? opt.value : null }))
                }
              />
            </Col>
          </Row>
          <Row className="align-items-end">
            <Col md={6} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Tipo de Solicitação
              </Form.Label>
              {/* DW-1019 — multi-seleção: nenhum selecionado = Todos.
                  closeMenuOnSelect=false para marcar vários sem reabrir o combo a cada clique.
                  O controle mostra o resumo "N selecionados" (MultiValueResumido); quem lista item
                  a item é o menu, via OpcaoComCheckbox + hideSelectedOptions=false — sem isso não
                  haveria onde enxergar o que está marcado. */}
              <Select
                placeholder="Todos"
                isMulti
                isClearable
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                styles={customStyles}
                components={{
                  DropdownIndicator,
                  MultiValue: MultiValueResumido,
                  Option: OpcaoComCheckbox,
                }}
                options={tiposSolicitacaoFiltro}
                value={tiposSolicitacaoFiltro.filter((t) =>
                  filtros.codigos_tipo_solicitacao.includes(t.value))}
                onChange={(opts) =>
                  setFiltros((prev) => ({
                    ...prev,
                    codigos_tipo_solicitacao: (opts || []).map((o) => o.value),
                  }))
                }
              />
            </Col>
            <Col md={3} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Data De
              </Form.Label>
              <Form.Control
                type="date"
                value={filtros.dt_ini}
                onChange={(e) => setFiltros({ ...filtros, dt_ini: e.target.value })}
                onBlur={(e) => setFiltros({ ...filtros, dt_ini: e.target.value })}
              />
            </Col>
            <Col md={3} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Data Até
              </Form.Label>
              <Form.Control
                type="date"
                value={filtros.dt_fim}
                onChange={(e) => setFiltros({ ...filtros, dt_fim: e.target.value })}
                onBlur={(e) => setFiltros({ ...filtros, dt_fim: e.target.value })}
              />
            </Col>
          </Row>
          {/* Botões em linha própria: com o Tipo de Solicitação ocupando md=6, não sobra
              largura para os 7 botões sem que eles quebrem de forma desalinhada.
              Dois grupos — à esquerda o que age sobre as solicitações, à direita o que age
              sobre o filtro/resultado. `flex-wrap` mantém o agrupamento em telas estreitas. */}
          <Row>
            <Col md={12} className="mb-2 d-flex flex-wrap justify-content-between">
              <div className="mb-1">
                <Button
                  variant="success"
                  className="mr-2"
                  onClick={() => abrirModal('nova', null)}
                >
                  <FaPlus className="mr-1" /> Nova Solicitação
                </Button>
                <Button
                  variant="warning"
                  className="mr-2"
                  disabled={selecionados.size === 0}
                  onClick={() => abrirModal('alterar', null)}
                >
                  <FaEdit className="mr-1" /> Alterar Status ({selecionados.size})
                </Button>
                <Button
                  variant="info"
                  className="mr-2"
                  disabled={selecionados.size !== 1}
                  onClick={() => {
                    const reg = registros.find((r) => selecionados.has(r.codigo));
                    abrirModal('requerimento', reg);
                  }}
                >
                  <FaFileAlt className="mr-1" /> Requerimento
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => abrirModal('tipos', null)}
                >
                  <FaCog className="mr-1" /> Tipos
                </Button>
              </div>
              <div className="mb-1">
                <Button variant="outline-secondary" className="mr-2" onClick={handleLimpar}>
                  Limpar
                </Button>
                <Button variant="primary" className="mr-2" onClick={handleFiltrar}>
                  Filtrar
                </Button>
                <Button
                  variant="outline-success"
                  disabled={exportando}
                  onClick={handleExportarExcel}
                >
                  <FaFileExcel className="mr-1" />
                  {exportando ? 'Extraindo...' : 'Extrair Excel'}
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Card de Dados */}
      <Card className="shadow-sm">
        <Card.Body className="p-0">
          {loading ? (
            <div className="p-3"><Loading /></div>
          ) : (
            <>
              {/* Desktop */}
              {/* Rolagem horizontal na grid, não na página: `responsive` envolve a tabela
                  num .table-responsive (overflow-x:auto), e `.debitos-desktop` faz a
                  contenção de largura via `contain: inline-size` (ver index.scss). Os dois
                  são necessários — só o .table-responsive não segura, porque ele cresce
                  junto com o ancestral. */}
              <div className="debitos-desktop">
                <Table striped bordered hover size="sm" responsive className="mb-0">
                  <thead>
                    <tr style={{ backgroundColor: '#f0f0f0' }}>
                      <th style={{ width: 36 }}>
                        <Form.Check
                          type="checkbox"
                          checked={registros.length > 0 && selecionados.size === registros.length}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelecionados(new Set(registros.map((r) => r.codigo)));
                            } else {
                              setSelecionados(new Set());
                            }
                          }}
                        />
                      </th>
                      {/* DW-1015 — grid espelha as 11 colunas da planilha extraída, nesta ordem */}
                      <th style={thCurta(112)} onClick={() => handleOrdenacao('dt_inicio')}>
                        Data Solicitação {iconeOrdenacao('dt_inicio')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('nome_usu_solicitou')}>
                        Solicitante {iconeOrdenacao('nome_usu_solicitou')}
                      </th>
                      <th style={thCurta(70)} onClick={() => handleOrdenacao('codigo_grupo_empresa')}>
                        GE {iconeOrdenacao('codigo_grupo_empresa')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('cidade')}>
                        Cidade {iconeOrdenacao('cidade')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('nome_empreendimento')}>
                        Empreendimento {iconeOrdenacao('nome_empreendimento')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('cpf_cnpj')}>
                        CPF/CNPJ {iconeOrdenacao('cpf_cnpj')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('apelido_conta')}>
                        Cliente {iconeOrdenacao('apelido_conta')}
                      </th>
                      <th style={thCurta(62)} onClick={() => handleOrdenacao('quadra')}>
                        Qd {iconeOrdenacao('quadra')}
                      </th>
                      <th style={thCurta(62)} onClick={() => handleOrdenacao('lote')}>
                        Lt {iconeOrdenacao('lote')}
                      </th>
                      <th style={thCurta(128)} onClick={() => handleOrdenacao('cad_prefeitura')}>
                        Cad. Prefeitura {iconeOrdenacao('cad_prefeitura')}
                      </th>
                      <th style={thCurta(106)} onClick={() => handleOrdenacao('data_venda')}>
                        Data Venda {iconeOrdenacao('data_venda')}
                      </th>
                      {/* DW-1019 — mesma posição do grid Delphi: última coluna de dados. */}
                      <th style={thSortStyle} onClick={() => handleOrdenacao('tipo_solicitacao')}>
                        Tipo de Solicitação {iconeOrdenacao('tipo_solicitacao')}
                      </th>
                      <th style={{ width: 152, whiteSpace: 'nowrap' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registrosPagina.length === 0 ? (
                      <tr>
                        <td colSpan={14} className="text-center py-3 text-muted">
                          Nenhum registro encontrado. Use os filtros acima e clique em Filtrar.
                        </td>
                      </tr>
                    ) : (
                      registrosPagina.map((reg) => (
                        <tr key={reg.codigo} style={getRowStyle(reg)}>
                          <td>
                            <Form.Check
                              type="checkbox"
                              checked={selecionados.has(reg.codigo)}
                              onChange={() => handleToggleSelecionado(reg.codigo)}
                            />
                          </td>
                          <td>
                            {reg.dt_inicio
                              ? new Date(reg.dt_inicio).toLocaleDateString('pt-BR')
                              : '-'}
                          </td>
                          <td>{reg.nome_usu_solicitou}</td>
                          <td>{reg.codigo_grupo_empresa}</td>
                          <td>{reg.cidade}</td>
                          <td>{reg.nome_empreendimento}</td>
                          <td>{reg.cpf_cnpj}</td>
                          {/* Cliente = Codigo_Conta - Apelido_Conta, igual ao modelo da planilha
                              e ao Delphi (.pas:2235). Não usa Cliente_Joia.Razao_Social. */}
                          <td>{`${reg.codigo_conta} - ${reg.apelido_conta || ''}`}</td>
                          <td>{reg.quadra}</td>
                          <td>{reg.lote}</td>
                          <td>{reg.cad_prefeitura}</td>
                          <td>
                            {reg.data_venda
                              ? new Date(reg.data_venda).toLocaleDateString('pt-BR')
                              : '-'}
                          </td>
                          <td>{reg.tipo_solicitacao}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              className="mr-1"
                              title="Ocorrências"
                              onClick={() => abrirModal('ocorrencias', reg)}
                            >
                              <FaComments />
                            </Button>
                            {isResponsavel && (
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                className="mr-1"
                                title="Anexar Documentos"
                                onClick={() => abrirModal('anexos', reg)}
                              >
                                <FaPaperclip />
                                {reg.qtde_anexo_rel > 0 && (
                                  <span className="ml-1">{reg.qtde_anexo_rel}</span>
                                )}
                              </Button>
                            )}
                            {isResponsavel && (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                title="Excluir"
                                onClick={() => handleExcluir(reg)}
                              >
                                <FaTrash />
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="debitos-mobile p-2">
                {registrosPagina.length === 0 ? (
                  <p className="text-center text-muted py-3">
                    Nenhum registro. Use os filtros e clique em Filtrar.
                  </p>
                ) : (
                  registrosPagina.map((reg) => (
                    <Card key={reg.codigo} className="mb-2 shadow-sm" style={getRowStyle(reg)}>
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <strong>
                            {reg.dt_inicio
                              ? new Date(reg.dt_inicio).toLocaleDateString('pt-BR')
                              : '-'}
                          </strong>
                          <span style={{ fontSize: '0.8rem', opacity: 0.75 }}>
                            GE {reg.codigo_grupo_empresa}
                          </span>
                        </div>
                        {/* DW-1015 — mesmas 11 colunas da planilha */}
                        <div style={{ fontSize: '0.85rem' }}>
                          <div><strong>Solicitante:</strong> {reg.nome_usu_solicitou}</div>
                          <div><strong>Cidade:</strong> {reg.cidade}</div>
                          <div><strong>Empreendimento:</strong> {reg.nome_empreendimento}</div>
                          <div><strong>CPF/CNPJ:</strong> {reg.cpf_cnpj}</div>
                          <div><strong>Cliente:</strong> {`${reg.codigo_conta} - ${reg.apelido_conta || ''}`}</div>
                          <div><strong>Qd/Lt:</strong> {reg.quadra} / {reg.lote}</div>
                          <div><strong>Cad. Prefeitura:</strong> {reg.cad_prefeitura}</div>
                          <div><strong>Data Venda:</strong> {reg.data_venda ? new Date(reg.data_venda).toLocaleDateString('pt-BR') : '-'}</div>
                          <div><strong>Tipo de Solicitação:</strong> {reg.tipo_solicitacao}</div>
                        </div>
                        <div className="mt-2 d-flex">
                          <Form.Check
                            type="checkbox"
                            label="Selecionar"
                            checked={selecionados.has(reg.codigo)}
                            onChange={() => handleToggleSelecionado(reg.codigo)}
                            className="mr-3"
                          />
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="mr-2"
                            onClick={() => abrirModal('ocorrencias', reg)}
                          >
                            <FaComments /> Ocorrências
                          </Button>
                          {isResponsavel && (
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              className="mr-2"
                              onClick={() => abrirModal('anexos', reg)}
                            >
                              <FaPaperclip /> Anexos
                              {reg.qtde_anexo_rel > 0 ? ` (${reg.qtde_anexo_rel})` : ''}
                            </Button>
                          )}
                          {isResponsavel && (
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleExcluir(reg)}
                            >
                              <FaTrash />
                            </Button>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  ))
                )}
              </div>

              {/* Paginação */}
              {registrosOrdenados.length > 0 && (
                <div className="d-flex flex-wrap align-items-center justify-content-between px-3 py-2 border-top">
                  <div style={{ fontSize: '0.85rem' }} className="text-muted">
                    Exibindo <strong>{inicioIdx + 1}</strong>–<strong>{fimIdx}</strong> de{' '}
                    <strong>{registrosOrdenados.length}</strong>
                  </div>
                  <div className="d-flex align-items-center">
                    <Form.Label className="mb-0 mr-2" style={{ fontSize: '0.85rem' }}>
                      Por página:
                    </Form.Label>
                    <Form.Control
                      as="select"
                      size="sm"
                      value={tamanhoPagina}
                      onChange={(e) => {
                        setTamanhoPaginaManual(true);
                        setTamanhoPagina(Number(e.target.value));
                      }}
                      style={{ width: 80 }}
                      className="mr-3"
                    >
                      {TAMANHOS_PAGINA.map((n) => (
                        <option key={n} value={n}>{n}</option>
                      ))}
                    </Form.Control>
                    <Pagination size="sm" className="mb-0">
                      <Pagination.First
                        disabled={paginaAtual === 1}
                        onClick={() => irParaPagina(1)}
                      />
                      <Pagination.Prev
                        disabled={paginaAtual === 1}
                        onClick={() => irParaPagina(paginaAtual - 1)}
                      />
                      {paginasVisiveis()[0] > 1 && <Pagination.Ellipsis disabled />}
                      {paginasVisiveis().map((p) => (
                        <Pagination.Item
                          key={p}
                          active={p === paginaAtual}
                          onClick={() => irParaPagina(p)}
                        >
                          {p}
                        </Pagination.Item>
                      ))}
                      {paginasVisiveis()[paginasVisiveis().length - 1] < totalPaginas && (
                        <Pagination.Ellipsis disabled />
                      )}
                      <Pagination.Next
                        disabled={paginaAtual === totalPaginas}
                        onClick={() => irParaPagina(paginaAtual + 1)}
                      />
                      <Pagination.Last
                        disabled={paginaAtual === totalPaginas}
                        onClick={() => irParaPagina(totalPaginas)}
                      />
                    </Pagination>
                  </div>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modais */}
      <NovaSolicitacaoModal
        show={modalAtivo === 'nova'}
        onHide={() => { setModalAtivo(null); setRegistroAtivo(null); }}
        onSuccess={handleSuccessModal}
        gruposEmpresa={gruposEmpresa}
        tiposSolicitacao={tiposSolicitacao}
      />

      <AlterarStatusModal
        show={modalAtivo === 'alterar'}
        onHide={() => { setModalAtivo(null); setSelecionados(new Set()); }}
        onSuccess={handleSuccessModal}
        solicitacoesSelecionadas={registrosSelecionadosArray}
        statusList={statusList}
        tiposSolicitacao={tiposSolicitacao}
      />

      <GerarRequerimentoModal
        show={modalAtivo === 'requerimento'}
        onHide={() => { setModalAtivo(null); setRegistroAtivo(null); }}
        onSuccess={handleSuccessModal}
        solicitacao={registroAtivo}
      />

      <TiposSolicitacaoModal
        show={modalAtivo === 'tipos'}
        onHide={() => {
          setModalAtivo(null);
          recarregarTiposSolicitacao();
        }}
      />

      {/* Fechar o modal NÃO refaz a listagem: o modal devolve a contagem final de anexos e só
          a linha correspondente é atualizada. Refazer a busca aqui custava uma query pesada,
          trocava a grid pelo spinner e descartava página/seleção — e, se o usuário tivesse
          mexido num filtro sem clicar em Filtrar, aplicava esse filtro sem ele pedir. */}
      <AnexosModal
        show={modalAtivo === 'anexos'}
        onHide={(qtdeAnexos) => {
          const codigoAfetado = registroAtivo ? registroAtivo.codigo : null;
          setModalAtivo(null);
          setRegistroAtivo(null);
          if (codigoAfetado != null && typeof qtdeAnexos === 'number') {
            setRegistros((prev) => prev.map((r) => (
              r.codigo === codigoAfetado ? { ...r, qtde_anexo_rel: qtdeAnexos } : r
            )));
          }
        }}
        solicitacao={registroAtivo}
      />

      <SolicitaDebMunicipioOcorrenciaDrawer
        open={modalAtivo === 'ocorrencias'}
        onClose={() => { setModalAtivo(null); setRegistroAtivo(null); }}
        codigoSolicitacao={registroAtivo ? registroAtivo.codigo : null}
        codigoUsuario={codigoUsuario}
      />

      <ModalConfirmacao
        show={confirmacao.show}
        title="Excluir Solicitação"
        message={
          confirmacao.item
            ? `Confirma a exclusão da solicitação #${confirmacao.item.codigo}?`
            : ''
        }
        onClose={handleConfirmarExclusao}
      />
    </Container>
  );
};

export default DebitosMunicipais;
